import React, { SyntheticEvent, useContext, useState } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../types/upload-field'
import { GridBlock, UploadFieldBlock } from '../../blocks'
import Instructions from '../../form-fields/upload/field-instructions'
import Title from '../../form-fields/upload/field-title'
import Toggle from '../../toggle'
import { CreationToolUploadContext } from '../manager'

const ToggleContainer = styled(UploadFieldBlock)`
    grid-column: span 1;
`

const TextfieldContainer = styled(UploadFieldBlock)`
    grid-column: span 2;
`

const Wrapper = styled(GridBlock)`
    grid-column: span 4;
    gap: 30px;
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationUploadCtaTextField = ({ className, field }: Props) => {
    const [isCTAOn, setIsCTAOn] = useState<boolean>(false)
    const { sourceUrl, ctaText, setCtaText } = useContext(CreationToolUploadContext)
    const placeholder = CreationToolUploadField.description(field)
    const maxLength = CreationToolUploadField.maxCharacterCount(field)

    const onInput = (e: SyntheticEvent<HTMLInputElement, InputEvent>) => {
        setCtaText(e.currentTarget.value || '')
    }

    const toggleCTA = () => {
        if (isCTAOn) {
            setCtaText('')
        }
        setIsCTAOn(!isCTAOn)
    }

    return sourceUrl ? (
        <Wrapper className={className} columns={3}>
            <ToggleContainer>
                <Title field={CreationToolUploadField.CtaToggle} />
                <Toggle isOn={isCTAOn} onToggle={() => toggleCTA()} />
            </ToggleContainer>
            {isCTAOn && (
                <TextfieldContainer>
                    <Title field={field} />
                    <input
                        {...{
                            defaultValue: ctaText,
                            type: 'text',
                            placeholder,
                            maxLength: maxLength || undefined,
                            onInput,
                        }}
                    />
                    <Instructions field={field} />
                </TextfieldContainer>
            )}
        </Wrapper>
    ) : null
}

export default CreationUploadCtaTextField
